import React, { useState } from 'react';
import { GOOGLE_SCRIPT_URL } from '../config';

export default function InquiryModal({ onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    organization: '',
    participants: '',
    format: 'Onsite',
    requirement: ''
  });
  const [formStatus, setFormStatus] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('Sending…');

    const messageBody = `
New Training Inquiry from Mr Excel Sri Lanka website (Modal Form):

• Name: ${formData.name}
• Email: ${formData.email}
• Phone: ${formData.phone}
• Organization: ${formData.organization || 'N/A'}
• Number of Participants: ${formData.participants || 'N/A'}
• Preferred Format: ${formData.format}
• Brief Training Requirement:
${formData.requirement}
    `;

    const templateParams = {
      name: formData.name,
      email: formData.email,
      title: 'New Training Inquiry (Modal)',
      message: messageBody,
    };

    try {
      if (GOOGLE_SCRIPT_URL && GOOGLE_SCRIPT_URL !== "YOUR_GOOGLE_APPS_SCRIPT_WEB_APP_URL") {
        await fetch(GOOGLE_SCRIPT_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(templateParams)
        });
      } else {
        console.warn("Google Apps Script URL is not configured. Please set GOOGLE_SCRIPT_URL in src/config.js");
      }

      setFormStatus('');
      setShowSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        organization: '',
        participants: '',
        format: 'Onsite',
        requirement: ''
      });
    } catch (error) {
      console.error("Failed to send inquiry via Google Apps Script:", error);
      setFormStatus('Failed to send inquiry. Please try again or contact info@mrexcelsrilanka.com.');
    }
  };

  return (
    <div className="modal open" onClick={onClose} style={{ zIndex: 2000 }}>
      <div 
        className="modal-dialog" 
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 'min(95%, 520px)',
          background: 'rgba(255, 255, 255, 0.98)',
          border: '1px solid rgba(11, 143, 85, 0.15)',
          borderRadius: '24px',
          padding: '32px',
          boxShadow: '0 24px 60px rgba(14, 33, 24, 0.2)',
          backdropFilter: 'blur(10px)',
          position: 'relative',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}
      >
        <button 
          className="modal-close" 
          type="button" 
          onClick={onClose}
          style={{
            position: 'absolute',
            right: '20px',
            top: '20px',
            border: 'none',
            background: 'none',
            fontSize: '1.6rem',
            color: '#607067',
            cursor: 'pointer',
            lineHeight: 1
          }}
        >
          &times;
        </button>

        {showSuccess ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{
              width: '74px',
              height: '74px',
              background: '#e9f6ef',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              boxShadow: '0 8px 20px rgba(11, 143, 85, 0.15)',
              animation: 'pulseGreen 2s infinite'
            }}>
              <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="#0b8f55" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <h3 style={{ fontSize: '1.4rem', fontWeight: 850, color: '#0e2118', margin: '0 0 10px 0' }}>
              Inquiry Sent!
            </h3>
            <p style={{ fontSize: '0.88rem', color: '#607067', lineHeight: '1.5', margin: '0 0 24px 0' }}>
              Thank you for reaching out. We have received your training inquiry and will recommend a suitable program shortly.
            </p>
            <button
              onClick={onClose}
              style={{
                background: '#0b8f55',
                color: '#fff',
                border: 'none',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: 800,
                fontSize: '0.94rem',
                cursor: 'pointer',
                boxShadow: '0 8px 20px rgba(11,143,85,0.2)',
                width: '100%'
              }}
            >
              Close Window
            </button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '24px' }}>
              <span className="eyebrow" style={{ color: '#0b8f55', fontWeight: 700 }}>Request Training</span>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 850, margin: '6px 0 0 0', color: '#0e2118' }}>
                Schedule Your Excel Training
              </h2>
              <p style={{ fontSize: '0.82rem', color: '#607067', marginTop: '6px' }}>
                Tell us about your team size, format, and current training requirements.
              </p>
            </div>

            <form onSubmit={handleFormSubmit} noValidate>
              <div style={{ display: 'grid', gap: '16px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div className="form-group" style={{ display: 'grid', gap: '4px' }}>
                    <label style={{ fontSize: '0.76rem', fontWeight: 800, color: '#35463d' }}>Name</label>
                    <input 
                      name="name" 
                      required 
                      value={formData.name} 
                      onChange={handleInputChange} 
                      style={{ padding: '10px 12px', border: '1px solid #cfdad1', borderRadius: '8px', fontSize: '0.86rem' }}
                    />
                  </div>
                  <div className="form-group" style={{ display: 'grid', gap: '4px' }}>
                    <label style={{ fontSize: '0.76rem', fontWeight: 800, color: '#35463d' }}>Email</label>
                    <input 
                      name="email" 
                      type="email" 
                      required 
                      value={formData.email} 
                      onChange={handleInputChange} 
                      style={{ padding: '10px 12px', border: '1px solid #cfdad1', borderRadius: '8px', fontSize: '0.86rem' }}
                    />
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div className="form-group" style={{ display: 'grid', gap: '4px' }}>
                    <label style={{ fontSize: '0.76rem', fontWeight: 800, color: '#35463d' }}>Phone Number</label>
                    <input 
                      name="phone" 
                      type="tel" 
                      required 
                      value={formData.phone} 
                      onChange={handleInputChange} 
                      style={{ padding: '10px 12px', border: '1px solid #cfdad1', borderRadius: '8px', fontSize: '0.86rem' }}
                    />
                  </div>
                  <div className="form-group" style={{ display: 'grid', gap: '4px' }}>
                    <label style={{ fontSize: '0.76rem', fontWeight: 800, color: '#35463d' }}>Organization</label>
                    <input 
                      name="organization" 
                      required 
                      value={formData.organization} 
                      onChange={handleInputChange} 
                      style={{ padding: '10px 12px', border: '1px solid #cfdad1', borderRadius: '8px', fontSize: '0.86rem' }}
                    />
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div className="form-group" style={{ display: 'grid', gap: '4px' }}>
                    <label style={{ fontSize: '0.76rem', fontWeight: 800, color: '#35463d' }}>No. of Participants</label>
                    <input 
                      name="participants" 
                      type="number" 
                      min="1" 
                      value={formData.participants} 
                      onChange={handleInputChange} 
                      style={{ padding: '10px 12px', border: '1px solid #cfdad1', borderRadius: '8px', fontSize: '0.86rem' }}
                    />
                  </div>
                  <div className="form-group" style={{ display: 'grid', gap: '4px' }}>
                    <label style={{ fontSize: '0.76rem', fontWeight: 800, color: '#35463d' }}>Preferred Format</label>
                    <select 
                      name="format" 
                      value={formData.format} 
                      onChange={handleInputChange}
                      style={{ padding: '10px 12px', border: '1px solid #cfdad1', borderRadius: '8px', fontSize: '0.86rem', background: '#fff' }}
                    >
                      <option value="Onsite">Onsite</option>
                      <option value="Online">Online</option>
                      <option value="Hybrid">Hybrid</option>
                      <option value="Not decided">Not decided</option>
                    </select>
                  </div>
                </div>

                <div className="form-group" style={{ display: 'grid', gap: '4px' }}>
                  <label style={{ fontSize: '0.76rem', fontWeight: 800, color: '#35463d' }}>Brief Training Requirement</label>
                  <textarea 
                    name="requirement" 
                    required 
                    value={formData.requirement} 
                    onChange={handleInputChange}
                    style={{ padding: '10px 12px', border: '1px solid #cfdad1', borderRadius: '8px', fontSize: '0.86rem', minHeight: '80px', resize: 'vertical' }}
                  ></textarea>
                </div>

                <div style={{ marginTop: '8px' }}>
                  <button 
                    className="btn btn-primary" 
                    type="submit"
                    style={{
                      width: '100%',
                      background: '#0b8f55',
                      borderColor: '#0b8f55',
                      color: '#fff',
                      padding: '12px',
                      borderRadius: '8px',
                      fontWeight: 800,
                      fontSize: '0.94rem',
                      cursor: 'pointer',
                      boxShadow: '0 8px 20px rgba(11,143,85,0.2)'
                    }}
                  >
                    {formStatus || 'Send Training Inquiry'}
                  </button>
                  <p className="form-note" style={{ textAlign: 'center', marginTop: '10px', fontSize: '0.7rem', color: '#607067' }}>
                    Your information is confidential and will only be used to recommend a program.
                  </p>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
      
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes pulseGreen {
          0% { box-shadow: 0 0 0 0 rgba(11, 143, 85, 0.4); }
          70% { box-shadow: 0 0 0 15px rgba(11, 143, 85, 0); }
          100% { box-shadow: 0 0 0 0 rgba(11, 143, 85, 0); }
        }
      `}} />
    </div>
  );
}
